import styled from "styled-components";

export const RabbitFestivalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow-x: hidden;
  height: 100vh;
`;

export const FestivalRoundButton = styled.div`
  border: 1px solid var(--Black-200, #b7b7b7);
  height: 26px;
  border-radius: 15px;
  padding-right: 8px;
  padding-left: 12px;
  font-weight: 600;
  font-size: 12px;
  color: #121212;
  display: flex;
  gap: 2px;
  justify-content: center;
  align-items: center;
`;
